export default "__VITE_ASSET__BiPZaRWA__"